import GeometryType from 'ol/geom/GeometryType.js';
import CircleStyle from 'ol/style/Circle.js';
import Fill from 'ol/style/Fill.js';
import Stroke from 'ol/style/Stroke.js';
import Style from 'ol/style/Style.js';

function createCustomEditingStyle(colorMain = [0, 153, 255], colorSecond = [255, 255, 255], width = 3) {
  const styles = {};
  const white = [...colorSecond.slice(0,3), 1];
  const blue = [...colorMain.slice(0,3), 1];
  styles[GeometryType.POLYGON] = [
    new Style({
      fill: new Fill({
        color: [...colorSecond.slice(0,3), 0.5]
      })
    })
  ];
  styles[GeometryType.MULTI_POLYGON] =
      styles[GeometryType.POLYGON];

  styles[GeometryType.LINE_STRING] = [
    new Style({
      stroke: new Stroke({
        color: white,
        width: width + 2
      })
    }),
    new Style({
      stroke: new Stroke({
        color: blue,
        width: width
      })
    })
  ];
  styles[GeometryType.MULTI_LINE_STRING] =
      styles[GeometryType.LINE_STRING];

  styles[GeometryType.CIRCLE] =
      styles[GeometryType.POLYGON].concat(
        styles[GeometryType.LINE_STRING]
      );


  styles[GeometryType.POINT] = [
    new Style({
      image: new CircleStyle({
        radius: width * 2,
        fill: new Fill({
          color: blue
        }),
        stroke: new Stroke({
          color: white,
          width: width / 2
        })
      }),
      zIndex: Infinity
    })
  ];
  styles[GeometryType.MULTI_POINT] =
      styles[GeometryType.POINT];

  styles[GeometryType.GEOMETRY_COLLECTION] =
      styles[GeometryType.POLYGON].concat(
        styles[GeometryType.LINE_STRING],
        styles[GeometryType.POINT]
      );

  return styles;
}

function getCustomStyleFunction(colorMain = [0, 153, 255], colorSecond = [255, 255, 255], width = 3) {
  const styles = createCustomEditingStyle(colorMain, colorSecond, width);
  return function(feature, resolution) {
    return styles[feature.getGeometry().getType()];
  };
}

export default {
  createCustomEditingStyle,
  getCustomStyleFunction
};



// WEBPACK FOOTER //
// ./src/utils/CustomEditingStyle.js